<div class="container-legende">
  <div class="tools-container">
    @if (!estCanvasElementsSupprimes()) {
      @for (tool of tools(); track tool.nodeType) {
        @if (tool.nodeType === 'Point-Depart') {
          <button
            class="legende cursor-pointer"
            #triggerPointDepart="cdkOverlayOrigin"
            [class.selected]="isPointDepartOpen"
            (click)="isPointDepartOpen = !isPointDepartOpen"
            hlmTooltipTrigger="Point de départ"
            aria-label="Créer un point de départ"
            cdkOverlayOrigin
            position="right"
          >
            <ng-icon [name]="tool.icon" />
          </button>
          <ng-template
            [cdkConnectedOverlayOrigin]="triggerPointDepart"
            [cdkConnectedOverlayOpen]="isPointDepartOpen"
            [cdkConnectedOverlayPositions]="[
              {
                originX: 'end',
                originY: 'top',
                overlayX: 'start',
                overlayY: 'top',
              },
            ]"
            (overlayOutsideClick)="isPointDepartOpen = false"
            cdkConnectedOverlay
          >
            <app-parcours-depart (onClick)="onClickHandler($event)"></app-parcours-depart>
          </ng-template>
        } @else if (tool.nodeType === 'Fin-Parcours') {
          <button
            class="legende cursor-pointer"
            #triggerFinParcours="cdkOverlayOrigin"
            [class.selected]="isFinParcoursOpen"
            [class]="{ 'disabled-button': isFinParcoursDisabled() }"
            [disabled]="isFinParcoursDisabled()"
            (click)="isFinParcoursOpen = !isFinParcoursOpen"
            hlmTooltipTrigger="Fin de parcours"
            aria-label="Ajouter une fin de parcours"
            cdkOverlayOrigin
            position="right"
          >
            <ng-icon [name]="tool.icon" />
          </button>

          <ng-template
            [cdkConnectedOverlayOrigin]="triggerFinParcours"
            [cdkConnectedOverlayOpen]="isFinParcoursOpen"
            [cdkConnectedOverlayPositions]="[
              {
                originX: 'end',
                originY: 'top',
                overlayX: 'start',
                overlayY: 'top',
              },
            ]"
            (overlayOutsideClick)="isFinParcoursOpen = false"
            cdkConnectedOverlay
          >
            <app-parcours-fin (onClick)="onClickFinParcours($event)"></app-parcours-fin>
          </ng-template>
        } @else {
          <app-legende-item
            [icon]="tool.icon"
            [previewLabel]="tool.titre"
            [fData]="tool"
            [isDisabled]="tool.isDisabled ?? false"
            [disableMessage]="tool.disableMessage ?? null"
            [tooltipMessage]="tool.titre"
            (onClick)="onClickHandler($event)"
            position="right"
          />
        }
      }
    }

    <button
      class="legende"
      [hlmTooltipTrigger]="
        typeElementSelectionne() ? 'Afficher le détail' : 'Veuillez sélectionner un élément pour afficher le détail'
      "
      (click)="onOpenDetails.emit()"
      hlmBtn
      variant="ghost"
      size="icon"
      position="right"
      aria-label="Afficher le détail"
    >
      <ng-icon name="lucideNotebookPen" aria-hidden="false" />
    </button>

    <button
      [hlmTooltipTrigger]="estCanvasElementsSupprimes() ? 'Retourner au Parcours' : 'Visualiser les étapes supprimées'"
      [class]="
        estCanvasElementsSupprimes()
          ? 'text-components-content-primary-darker bg-components-background-primary-lightest size-[40px]'
          : 'legende'
      "
      (click)="onToggleCanvasElementSupprimes.emit()"
      hlmBtn
      variant="ghost"
      size="icon"
      position="right"
      aria-label="Visualiser les étapes supprimées ou retourner au parcours"
    >
      <ng-icon name="lucideArchiveX" aria-hidden="false" />
    </button>
  </div>

  @if (userStore.isAdmin()) {
    <div class="tools-container">
      <button
        class="legende"
        [hlmTooltipTrigger]="(!estVerrouille() ? 'Valider' : 'Dévalider') + ' le parcours'"
        (click)="onToggleValidationParcours.emit()"
        hlmBtn
        variant="ghost"
        size="icon"
        position="right"
        aria-label="Valider le parcours"
      >
        <ng-icon name="lucideListTodo" aria-hidden="false" />
      </button>
    </div>
  }
</div>
